<template>
    <v-container container--fluid mobile-responsive>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left" v-if="!seasons" v-cloak>
                <h1 class="grey--text lighten-3 mb-2">Team Nomination</h1>
                <v-alert class="mt-4" :value="true" outlined transition="scale-transition" type="info">Team entries are closed for the moment...</v-alert>
            </v-flex>
            <v-flex xs12 class="text-left" v-else-if="seasons > 0" v-cloak>
                <h1 class="grey--text lighten-3 mb-2">Team Nomination</h1>
                <p>
                    Welcome to the {{ appNameUrls.client }} online system. Here, you will be able to enter your Team into the next competition. Teams MUST be aware of age
                    specifications and competition schedule when submitting entry.
                </p>
                <p class="error--text font-weight-bold">Disclaimer: The {{ appNameUrls.client }} online platform is a "first to checkout" online system. While every effort is made to ensure customers receive products in their shopping cart, products may be sold out before reaching the payment window.</p>
                <p class="font-italic">All fields marked * are mandatory.</p>

                <v-overlay :absolute="true" :value="paysuccess" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark color="cyan darken-2" @click="paysuccess = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <v-snackbar v-model="overlay" :multi-line="true" bottom color="primary" text>
                    <span v-html="overlayText"></span>

                    <template v-slot:action="{ attrs }">
                        <v-btn :color="overlayColor" text v-bind="attrs" @click="overlay = false"> Close<v-icon medium right>highlight_off</v-icon> </v-btn>
                    </template>
                </v-snackbar>

                <v-stepper v-model.lazy="teamnomStep" vertical>
                    <v-stepper-step :editable="editablePanel" :complete="teamnomStep > 1" step="1" :color="teamnomStep > 1 ? 'success' : 'primary'">
                        Previous Team Selection
                        <small class="secondary--text font-weight-bold">Optional</small>
                    </v-stepper-step>

                    <v-stepper-content step="1">
                        <v-form class="overwrite-inputs" data-vv-scope="step1" lazy-validation>
                            <v-card color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm12 md12 v-if="!skTmVal">
                                        <v-select
                                            clearable
                                            prepend-icon="list"
                                            :loading="teamNomStatus"
                                            :items="teams"
                                            v-model.lazy="teamSel"
                                            return-object
                                            single-line
                                            item-text="t_name"
                                            item-value="t_id"
                                            label="Previous Teams"
                                        >
                                            <template slot="item" slot-scope="data">
                                                {{ data.item.t_name }} - {{ data.item.t_division }} - {{ data.item.t_season }}
                                            </template>
                                        </v-select>
                                    </v-flex>
                                    <v-flex v-else>
                                        <div class="secondary--text font-weight-bold">Players Optional</div>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                            <v-btn color="secondary" v-if="!skTmVal" @click="copyTeam" :disabled="!teamSel"><v-icon medium dark left>file_copy</v-icon>Copy Team</v-btn>
                            <v-btn color="primary" @click.native="submitStep('step1')">Continue</v-btn>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step2')]"
                        :editable="editablePanel"
                        :complete="teamnomStep > 2"
                        step="2"
                        :color="teamnomStep > 2 ? 'success' : 'primary'"
                    >
                        Team Name & Grade
                    </v-stepper-step>

                    <v-stepper-content step="2">
                        <v-form class="overwrite-inputs" data-vv-scope="step2" lazy-validation>
                            <v-card color="grey lighten-5" class="pa-sm-3 pa-0  mb-5 elevetation-6">
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            prepend-icon="group_work"
                                            label="Team Name*"
                                            v-model.lazy="team.teamname"
                                            v-validate="'required'"
                                            :error="errors.has('team.teamname')"
                                            :error-messages="errors.collect('team.teamname')"
                                            data-vv-name="team.teamname"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 v-if="showprev">
                                        <v-text-field
                                            prepend-icon="group_work"
                                            label="Previous Team Name*"
                                            v-model.lazy="team.prevteamname"
                                            :error="errors.has('team.prevteamname')"
                                            :error-messages="errors.collect('team.prevteamname')"
                                            data-vv-name="team.prevteamname"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-select
                                            prepend-icon="list"
                                            :loading="teamNomStatus"
                                            :items="grades"
                                            label="Grade"
                                            v-model.lazy="team.grade"
                                            @change="onChangeGrade"
                                            v-validate="'required'"
                                            :error="errors.has('team.grade')"
                                            :error-messages="errors.collect('team.grade')"
                                            data-vv-name="team.grade"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete
                                            prepend-icon="list"
                                            clearable
                                            :open-on-clear="true"
                                            :loading="teamNomStatus"
                                            :items="divisiongroups"
                                            label="Division Group"
                                            v-model.lazy="team.divisiongroup"
                                            @change="onChangeDivisionGroup"
                                            v-validate="'required'"
                                            :error="errors.has('team.divisiongroups')"
                                            :error-messages="errors.collect('team.divisiongroups')"
                                            data-vv-name="team.divisiongroups"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete
                                            prepend-icon="list"
                                            clearable
                                            :open-on-clear="true"
                                            :loading="teamNomStatus"
                                            :items="divisions"
                                            label="Preferred Division"
                                            v-model.lazy="team.division"
                                            @change="onChangeDivision"
                                            v-validate="'required'"
                                            :error="errors.has('team.divisions')"
                                            :error-messages="errors.collect('team.divisions')"
                                            data-vv-name="team.divisions"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 v-if="showpreferredwaitlist">
                                        <v-autocomplete
                                            prepend-icon="list"
                                            clearable
                                            :open-on-clear="true"
                                            :loading="teamNomStatus"
                                            :items="preferreddivisions"
                                            label="Preferred Choice"
                                            v-model.lazy="team.preferreddivision"
                                            @change="onChangePreferredDivision"
                                            v-validate="requiredpreferredwaitlist ? 'required' : ''"
                                            :error="errors.has('team.preferreddivisions')"
                                            :error-messages="errors.collect('team.preferreddivisions')"
                                            data-vv-name="team.preferreddivisions"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                            <v-btn color="primary" @click.native="submitStep('step2')" :disabled="errors.any('step2')">Continue</v-btn>
                            <v-btn color="error" text @click.native="teamnomStep = 1">Back</v-btn>
                            <div v-if="errors.any('step2')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step3')]"
                        :editable="editablePanel"
                        :complete="teamnomStep > 3"
                        step="3"
                        :color="teamnomStep > 3 ? 'success' : 'primary'"
                    >
                        Team Manager
                    </v-stepper-step>

                    <v-stepper-content step="3">
                        <v-form class="overwrite-inputs" data-vv-scope="step3" lazy-validation>
                            <v-card color="grey lighten-5" class="pa-sm-3 pa-0  mb-5 elevetation-6">
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field
                                            prepend-icon="person"
                                            label="Firstname*"
                                            v-model.lazy.trim="manager.firstname"
                                            v-validate="'required'"
                                            :error="errors.has('manager.firstname')"
                                            :error-messages="errors.collect('manager.firstname')"
                                            data-vv-name="manager.firstname"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field
                                            prepend-icon="person"
                                            label="Lastname*"
                                            v-model.lazy.trim="manager.lastname"
                                            v-validate="'required'"
                                            :error="errors.has('manager.lastname')"
                                            :error-messages="errors.collect('manager.lastname')"
                                            data-vv-name="manager.lastname"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm6 md6>
                                        <v-menu
                                            ref="menu"
                                            v-model.lazy="modalDOB.manager"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="dateDOB.manager"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model.lazy.trim="manager.dob"
                                                    label="Date of Birth*"
                                                    prepend-icon="event"
                                                    v-mask="'##/##/####'"
                                                    hint="dd/mm/yyyy"
                                                    persistent-hint
                                                    v-validate="'required|date_format:dd/MM/yyyy'"
                                                    :error="errors.has('manager.dob')"
                                                    :error-messages="errors.collect('manager.dob')"
                                                    data-vv-name="manager.dob"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model.lazy="dateDOB.manager" :max="maxDate" @change="save('manager')" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="modalDOB.manager = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.menu.save(dateDOB.manager)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-select
                                            prepend-icon="perm_identity"
                                            :items="gender"
                                            label="Gender*"
                                            v-model.lazy.trim="manager.gender"
                                            v-validate="'required'"
                                            :error="errors.has('manager.gender')"
                                            :error-messages="errors.collect('manager.gender')"
                                            data-vv-name="manager.gender"
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            label="Email*"
                                            prepend-icon="email"
                                            v-model.lazy.trim="manager.email"
                                            v-validate="'required|email'"
                                            :error="errors.has('manager.email')"
                                            :error-messages="errors.collect('manager.email')"
                                            data-vv-name="manager.email"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            label="Mobile*"
                                            prepend-icon="smartphone"
                                            v-model.lazy.trim="manager.mobile"
                                            v-mask="'##########'"
                                            hint="e.g. 0412345678"
                                            persistent-hint
                                            v-validate="{ required: true, regex: /^04[0-9]{8}$/ }"
                                            :error="errors.has('manager.mobile')"
                                            :error-messages="errors.collect('manager.mobile')"
                                            data-vv-name="manager.mobile"
                                            maxlength="10"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field
                                            label="Address*"
                                            prepend-icon="location_city"
                                            v-model.lazy.trim="manager.address"
                                            v-validate="'required'"
                                            :error="errors.has('manager.address')"
                                            :error-messages="errors.collect('manager.address')"
                                            data-vv-name="manager.address"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-autocomplete
                                            cache-items
                                            :items="localities"
                                            persistent-hint
                                            hint="Type 2 or more characters"
                                            label="Suburb*"
                                            prepend-icon="location_city"
                                            v-model.lazy="manager.suburb"
                                            v-validate="'required'"
                                            :error="errors.has('manager.suburb')"
                                            :error-messages="errors.collect('manager.suburb')"
                                            data-vv-name="manager.suburb"
                                            @change="setLocation(manager.suburb, 'manager')"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field
                                            label="Postcode*"
                                            prepend-icon="location_on"
                                            v-model.lazy.trim="manager.postcode"
                                            v-validate="'required'"
                                            :error="errors.has('manager.postcode')"
                                            :error-messages="errors.collect('manager.postcode')"
                                            data-vv-name="manager.postcode"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-autocomplete
                                            cache-items
                                            :items="states"
                                            item-text="text"
                                            item-value="value"
                                            label="State*"
                                            prepend-icon="location_on"
                                            v-model.lazy.trim="manager.state"
                                            v-validate="'required'"
                                            :error="errors.has('manager.state')"
                                            :error-messages="errors.collect('manager.state')"
                                            data-vv-name="manager.state"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap class="pa-2">
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field label="Home Phone" prepend-icon="phone" v-model.lazy.trim="manager.phone" maxlength="10"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <v-text-field label="Workphone" prepend-icon="work" v-model.lazy.trim="manager.workphone" maxlength="10"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-alert :value="true" color="primary lighten-1" icon="priority_high" outlined>
                                            <p>
                                                On behalf of the team, I as Team Manager acknowledge and agree to abide by the {{ appNameUrls.assoc_name }} (1) Competition By-Laws,
                                                (2) Fee Schedule, (3) Codes of Conduct, and (4) Risk Policy. All our policies and procedures are located in one place for easy
                                                reference: <a class="font-weight-bold" href="/about/policy-procedures/" target="_blank">Policies and Procedures</a>
                                            </p>
                                        </v-alert>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-checkbox
                                            class="mt-1 chk-label"
                                            v-model.lazy.trim="manager.agreed"
                                            v-validate="'required:true'"
                                            :error="errors.has('manager.agreed')"
                                            :error-messages="errors.collect('manager.agreed')"
                                            data-vv-name="manager.agreed"
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    * I have read the {{ appNameUrls.assoc_name }} Competition By-Laws, Fee Schedule, Codes of Conduct and Risk Policy and, on
                                                    behalf of the team, agree to abide by them. I declare that I am not a person prohibited by Child Protection (Prohibited
                                                    Employment) Act 1998 from seeking, undertaking or remaining in child-related employment.
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                            <v-btn color="primary" @click.native="submitStep('step3')" :disabled="errors.any('step3')">Continue</v-btn>
                            <v-btn color="error" text @click.native="teamnomStep = 2">Back</v-btn>
                            <div v-if="errors.any('step3')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step4')]"
                        :editable="editablePanel"
                        :complete="teamnomStep > 4"
                        step="4"
                        :color="teamnomStep > 4 ? 'success' : 'primary'"
                    >
                        Team Coach
                        <small class="secondary--text font-weight-bold">Optional</small>
                    </v-stepper-step>

                    <v-stepper-content step="4">
                        <v-form class="overwrite-inputs" data-vv-scope="step4" lazy-validation>
                            <v-card color="grey lighten-5" class="pa-sm-3 pa-2 mb-5 elevetation-6">
                                <v-switch v-model="coach.showCoach" color="success" :value="!coach.showCoach" inset label="Add a team coach"></v-switch>
                                <v-sheet v-if="coach.showCoach">
                                    <v-layout row wrap class="pa-2">
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                prepend-icon="person"
                                                label="Firstname*"
                                                v-model.lazy.trim="coach.firstname"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.firstname')"
                                                :error-messages="errors.collect('coach.firstname')"
                                                data-vv-name="coach.firstname"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                prepend-icon="person"
                                                label="Lastname*"
                                                v-model.lazy.trim="coach.lastname"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.lastname')"
                                                :error-messages="errors.collect('coach.lastname')"
                                                data-vv-name="coach.lastname"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="pa-2">
                                        <v-flex xs12 sm6 md6>
                                            <v-menu
                                                ref="menu"
                                                v-model.lazy="modalDOB.coach"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="dateDOB.coach"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model.lazy.trim="coach.dob"
                                                        label="Date of Birth*"
                                                        prepend-icon="event"
                                                        v-mask="'##/##/####'"
                                                        hint="dd/mm/yyyy"
                                                        persistent-hint
                                                        v-on="on"
                                                        v-validate="`${coach.showCoach ? 'required|date_format:dd/MM/yyyy' : ''}`"
                                                        :error="errors.has('coach.dob')"
                                                        :error-messages="errors.collect('coach.dob')"
                                                        data-vv-name="coach.dob"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model.lazy="dateDOB.coach" :max="maxDate" @change="save('coach')" scrollable>
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="modalDOB.coach = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="$refs.menu.save(dateDOB.coach)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-select
                                                prepend-icon="perm_identity"
                                                :items="gender"
                                                label="Gender*"
                                                v-model.lazy.trim="coach.gender"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.gender')"
                                                :error-messages="errors.collect('coach.gender')"
                                                data-vv-name="coach.gender"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field
                                                label="Email*"
                                                prepend-icon="email"
                                                v-model.lazy.trim="coach.email"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.email')"
                                                :error-messages="errors.collect('coach.email')"
                                                data-vv-name="coach.email"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="pa-2">
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field
                                                label="Mobile*"
                                                prepend-icon="smartphone"
                                                v-model.lazy.trim="coach.mobile"
                                                v-mask="'##########'"
                                                hint="e.g. 0412345678"
                                                persistent-hint
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.mobile')"
                                                :error-messages="errors.collect('coach.mobile')"
                                                data-vv-name="coach.mobile"
                                                maxlength="10"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-text-field
                                                label="Address*"
                                                prepend-icon="location_city"
                                                v-model.lazy.trim="coach.address"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.address')"
                                                :error-messages="errors.collect('coach.address')"
                                                data-vv-name="coach.address"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 sm12 md12>
                                            <v-autocomplete
                                                cache-items
                                                :items="localities"
                                                persistent-hint
                                                hint="Type 2 or more characters"
                                                label="Suburb*"
                                                prepend-icon="location_city"
                                                v-model.lazy.trim="coach.suburb"
                                                @change="setLocation(coach.suburb, 'coach')"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.suburb')"
                                                :error-messages="errors.collect('coach.suburb')"
                                                data-vv-name="coach.suburb"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="pa-2">
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                label="Postcode*"
                                                prepend-icon="location_on"
                                                v-model.lazy.trim="coach.postcode"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.postcode')"
                                                :error-messages="errors.collect('coach.postcode')"
                                                data-vv-name="coach.postcode"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-autocomplete
                                                cache-items
                                                :items="states"
                                                item-text="text"
                                                item-value="value"
                                                label="State*"
                                                prepend-icon="location_on"
                                                v-model.lazy.trim="coach.state"
                                                v-validate="coach.showCoach ? 'required' : ''"
                                                :error="errors.has('coach.state')"
                                                :error-messages="errors.collect('coach.state')"
                                                data-vv-name="coach.state"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="pa-2">
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field label="Home Phone" prepend-icon="phone" v-model.lazy.trim="coach.phone" maxlength="10"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field label="Workphone" prepend-icon="work" v-model.lazy.trim="coach.workphone" maxlength="10"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-checkbox
                                                class="mt-1 chk-label"
                                                v-model.lazy.trim="coach.agreed"
                                                v-validate="coach.showCoach ? 'required:true' : ''"
                                                :error="errors.has('coach.agreed')"
                                                :error-messages="errors.collect('coach.agreed')"
                                                data-vv-name="coach.agreed"
                                            >
                                                <template v-slot:label>
                                                    <div>
                                                        * I declare that the Team Coach is not a person prohibited by Child Protection (Prohibited Employment) Act 1998 from
                                                        seeking, undertaking or remaining in child-related employment.
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-sheet>
                            </v-card>
                            <v-btn color="primary" @click.native="submitStep('step4')" :disabled="errors.any('step4')">Continue</v-btn>
                            <v-btn color="error" text @click.native="teamnomStep = 3">Back</v-btn>
                            <div v-if="errors.any('step4')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step
                        :rules="[() => !errors.any('step5')]"
                        :editable="editablePanel"
                        :complete="teamnomStep > 5"
                        step="5"
                        :color="teamnomStep > 5 ? 'success' : 'primary'"
                    >
                        Players
                    </v-stepper-step>

                    <v-stepper-content step="5">
                        <v-form class="overwrite-inputs" data-vv-scope="step5" lazy-validation>
                            <input type="hidden" v-if="!skTmVal && !skipVal && minPlayers > 0" v-validate:length="'min_value:'+minPlayers" name="players_list_min" />
                            <input type="hidden" v-if="maxPlayers" v-validate:length="'max_value:'+maxPlayers" name="players_list_max" />
                            <v-card color="grey lighten-5" class="pa-3 mb-5 elevetation-6">
                                <div v-if="!skTmVal && !skipVal && minPlayers > 0" class="secondary--text text--lighten-1 mb-4 subtitle-2 font-weight-bold">
                                    <v-icon color="secondary lighten-1" medium left>info</v-icon> Minimum: {{minPlayers}} players <span v-if="maxPlayers"> - Maximum: {{maxPlayers}} players</span>
                                    <v-divider light class="my-3"></v-divider>
                                </div>
                                <div v-else>
                                    <div class="secondary--text font-weight-bold">Players Optional</div>
                                    <v-divider light class="my-3"></v-divider>
                                </div>
                                <div v-for="(player, index) in players" :key="index">
                                    <v-layout row wrap align-end class="pa-2">
                                        <v-flex xs12 sm12 md12>
                                            Player #{{ index + 1 }}
                                            <span v-if="player.click && player.confirm">
                                                Added - {{ player.firstname }} {{ player.lastname }}
                                                <v-btn color="error" small outlined @click="removePlayer(index)" class="my-3 my-sm-0 mx-sm-6 mx-0 mob-block"
                                                    ><v-icon dark small left>remove_circle</v-icon> Remove player</v-btn
                                                ></span
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap align-end class="pa-0" v-if="!(player.click && player.confirm)">
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                :disabled="player.confirm || player.copied"
                                                prepend-icon="person"
                                                label="Firstname*"
                                                v-model.lazy.trim="player.firstname"
                                                v-validate="'required'"
                                                :error="errors.has('player.firstname_' + index)"
                                                :error-messages="errors.collect('player.firstname_' + index)"
                                                :name="'player.firstname_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field
                                                :disabled="player.confirm || player.copied"
                                                prepend-icon="person"
                                                label="Lastname*"
                                                v-model.lazy.trim="player.lastname"
                                                v-validate="'required'"
                                                :error="errors.has('player.lastname_' + index)"
                                                :error-messages="errors.collect('player.lastname_' + index)"
                                                :name="'player.lastname_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6 v-if="!player.copied">
                                            <v-select
                                                :disabled="player.confirm || player.copied"
                                                prepend-icon="perm_identity"
                                                :items="gender"
                                                label="Gender*"
                                                v-model.lazy.trim="player.gender"
                                                v-validate="'required'"
                                                :error="errors.has('player.gender_' + index)"
                                                :error-messages="errors.collect('player.gender_' + index)"
                                                :name="'player.gender_' + index"
                                            ></v-select>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6 v-if="!player.copied">
                                            <v-text-field
                                                :disabled="player.confirm || player.copied"
                                                prepend-icon="event"
                                                v-mask="'##/##/####'"
                                                hint="dd/mm/yyyy"
                                                persistent-hint
                                                label="Date of Birth*"
                                                v-model.lazy.trim="player.dob"
                                                v-validate="'required|date_format:dd/MM/yyyy'"
                                                :error="errors.has('player.dob_' + index)"
                                                :error-messages="errors.collect('player.dob_' + index)"
                                                :name="'player.dob_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12 v-if="player.requireEmail && !player.copied">
                                            <v-text-field
                                                :disabled="player.confirm || player.copied"
                                                label="Email*"
                                                prepend-icon="email"
                                                v-model.lazy.trim="player.email"
                                                v-validate="'email|required'"
                                                :error="errors.has('player.email_' + index)"
                                                :error-messages="errors.collect('player.email_' + index)"
                                                :name="'player.email_' + index"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm3 md3>
                                            <v-checkbox v-model.lazy.trim="player.rep" label="Representative Player?"></v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6 class="text-left">
                                            <v-btn
                                                :color="!player.confirm && player.click ? 'red white--text' : 'success white--text'"
                                                :disabled="player.click && player.confirm"
                                                small
                                                @click="checkPlayer(index)"
                                                class="mt-3 mb-5 mx-0 mob-block"
                                                v-model.lazy.trim="player.click"
                                                v-validate="'required:true'"
                                                :error="errors.has('player.click_' + index)"
                                                :name="'player.click_' + index"
                                                ><v-icon dark small left>{{ player.click && player.confirm ? "how_to_reg" : "person_add" }}</v-icon
                                                >{{ player.btn }}</v-btn
                                            >
                                            <span class="caption red--text text--darken-1" v-if="player.status && player.status != 'Player Found'">{{ player.status }}</span>
                                            <span v-if="errors.has('player.click_' + index)" class="caption red--text text--darken-1">Must click "ADD PLAYER" button</span>
                                        </v-flex>
                                        <v-flex xs12 sm3 md3 class="text-right">
                                            <v-btn color="error" small outlined @click="removePlayer(index)" class="my-3 mx-0 mob-block"
                                                ><v-icon dark small left>remove_circle</v-icon> Remove player</v-btn
                                            >
                                        </v-flex>
                                    </v-layout>
                                    <v-divider light class="my-3"></v-divider>
                                </div>
                                <v-btn color="secondary" v-if="!skTmVal && !skipVal && minPlayers > 0" small @click="addPlayer"><v-icon dark small left>add_circle</v-icon>ADDITIONAL PLAYER</v-btn>
                            </v-card>
                            <v-btn color="primary" @click.native="submitStep('step5')" :disabled="errors.any('step5')">Continue</v-btn>
                            <v-btn color="error" text @click.native="teamnomStep = 4">Back</v-btn>
                            <div v-if="errors.any('step5')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-step :editable="editablePanel" :complete="teamnomStep > 6" step="6" :color="teamnomStep > 6 ? 'success' : 'primary'">
                        Note
                    </v-stepper-step>

                    <v-stepper-content step="6">
                        <v-card color="grey lighten-5" class="pa-3 mb-5 elevetation-6">
                            <p>
                                If you know a player has played at {{ appNameUrls.assoc_name }} but is showing NOT FOUND. Please enter their first name, surname & date of birth in
                                the notes section & staff will add to your team roster.
                            </p>
                            <v-textarea v-model.lazy.trim="note" outlined clearable></v-textarea>
                        </v-card>
                        <v-btn color="primary" @click="teamnomStep = 7">Continue</v-btn>
                        <v-btn color="error" text @click="teamnomStep = 5">Back</v-btn>
                    </v-stepper-content>

                    <v-stepper-step :editable="editablePanel" :complete="teamnomStep > 7" step="7" :color="teamnomStep > 7 ? 'success' : 'primary'">
                        Team Nomination Review
                    </v-stepper-step>

                    <v-stepper-content step="7">
                        <v-card color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                            <div class="Ftable">
                                <div class="Ftable__row Ftable__header">
                                    <div class="Ftable__item cols-2 text-left">Team Nomination</div>
                                    <div class="Ftable__item text-right"></div>
                                    <div class="Ftable__item text-right">Price</div>
                                </div>
                                <div class="Ftable__row">
                                    <div class="Ftable__item cols-2 text-left">
                                        <span>{{ teamnominationCart.p_name }}</span>
                                    </div>
                                    <div class="Ftable__item text-right"></div>
                                    <div class="Ftable__item text-right">
                                        <span>{{ user.sk_tm ? 0 : teamnominationCart.p_price | currency }}</span>
                                    </div>
                                </div>
                                <div class="Ftable__row">
                                    <div class="Ftable__item cols-2 no-border right-border top-border"><b>Division:</b> {{ gradeDiv }}</div>
                                    <div class="Ftable__item text-right">
                                        <span><strong>Subtotal</strong></span>
                                    </div>
                                    <div class="Ftable__item text-right">
                                        <span>{{ user.sk_tm ? 0 : subTotal | currency("$") }}</span>
                                    </div>
                                </div>
                                <div class="Ftable__row">
                                    <div class="Ftable__item cols-2 no-border right-border bottom-border">
                                        <span v-if="showprev"><b>Previous Team:</b> {{ team.prevteamname }}<br /></span><b>Team:</b> {{ team.teamname }}
                                    </div>
                                    <div class="Ftable__item text-right">
                                        <span><strong>Tax</strong></span>
                                    </div>
                                    <div class="Ftable__item text-right">
                                        <span>{{ user.sk_tm ? 0 : taxTotal | currency("$") }}</span>
                                    </div>
                                </div>
                                <div class="Ftable__row">
                                    <div class="Ftable__item cols-2 no-border right-border top-border">
                                        <div v-if="Object.keys(manager).length > 0">
                                            <b>Manager:</b> <span>{{ manager.firstname }} {{ manager.lastname }}</span>
                                        </div>
                                        <div v-if="Object.keys(coach).length > 0">
                                            <b>Coach:</b> <span>{{ coach.firstname }} {{ coach.lastname }}</span>
                                        </div>
                                        <div v-if="players.length > 0">
                                            <b>Players:</b>
                                            <span v-for="(player, index) in players" :key="index"
                                                ><span v-if="index != 0">, </span><span>{{ player.firstname }} {{ player.lastname }}</span></span
                                            >
                                        </div>
                                    </div>
                                    <div class="Ftable__item text-right">
                                        <span><strong>Total</strong></span>
                                    </div>
                                    <div class="Ftable__item text-right">
                                        <span>{{ user.sk_tm ? 0 : grandTotal | currency("$") }}</span>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                        <v-btn color="primary" @click="teamnomStep = 8">Continue</v-btn>
                        <v-btn color="error" text @click="teamnomStep = 6">Back</v-btn>
                    </v-stepper-content>

                    <v-stepper-step :rules="[() => !errors.any('step8')]" :editable="editablePanel" step="8">
                        Make Online Payment
                        <small
                            v-if="paymentErrors.any() && !paymentErrors.has('error_response')"
                            class="caption font-weight-bold secondary--text"
                            v-html="getPaymentMessage"
                        ></small>
                        <small
                            v-if="paymentErrors.any() && paymentErrors.has('error_response')"
                            class="caption font-weight-bold secondary--text"
                            v-html="paymentErrors.get('error_response')"
                        ></small>
                    </v-stepper-step>

                    <v-stepper-content step="8">
                        <donation v-if="showCpDonation"></donation>

                        <v-card color="grey lighten-5" class="mb-5 elevetation-6">
                            <v-card-text>
                                <component :is="ftGateway" v-if="grandTotal > 0 && user.sk_tm == false" @submitted-pay="submitPay"></component>
                                <v-alert dense outlined v-if="grandTotal <= 0 || user.sk_tm == true" type="info"
                                    >No Payment required. Click button below to complete process.</v-alert
                                >
                            </v-card-text>
                        </v-card>

                        <v-btn :loading="payLoading" :disabled="!validPaymentForm" color="primary" @click="payTeamNomination" class="mr-2 text-left"
                            ><v-icon left>local_atm</v-icon>{{ payHtml }}: {{ user.sk_tm ? 0 : grandTotal | currency }}</v-btn
                        >
                        <v-btn v-if="grandTotal > 0 && user.sk_tm == false" @click="clearPay" color="warning" :disabled="payLoading" class="text-left"
                            >clear
                            <v-icon right>clear</v-icon>
                        </v-btn>

                        <v-alert class="mt-4" v-model.lazy.trim="alert" outlined transition="scale-transition" dismissible type="error">
                            Error! Please check all steps above for errors
                        </v-alert>
                    </v-stepper-content>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

import { EventBus } from "@shared/EventBus.js";
import Eway from "@components/gateways/Eway.vue";
import MerchantWarrior from "@components/gateways/MerchantWarrior.vue";
import Donation from "@components/donation/Donation.vue";

export default {
    name: "TeamNominationModule",
    components: {
        eway: Eway,
        merchantWarrior: MerchantWarrior,
        donation: Donation,
    },
    $_veeValidate: {
        validator: "new",
    },
    data() {
        return {
            teamnomStep: 1,

            validPaymentForm: true,
            discountTotal: 0,

            gender: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }],
            search: null,
            searchC: null,
            // localities: [],
            // locSubs: [],
            // locSubsC: [],

            teamSel: null,
            manager: {},
            coach: {
                showCoach: false,
            },
            team: {},
            showprev: true,
            showpreferredwaitlist: false,
            requiredpreferredwaitlist: false,
            note: "",
            players: [],
            alert: false,
            modalDOB: { manager: false, coach: false },
            dateDOB: { manager: null, coach: null },
            maxDate: moment().format("YYYY-MM-DD"),

            editablePanel: false,
            gradeDiv: "",
            minPlayers: 5,
            maxPlayers: null,
            skipVal: false,
            skTmVal: false,

            overlayColor: "primary",
            overlay: false,
            paysuccess: false,
            overlayText: "",
            timeout: 1000,

            // ftGateway: process.env.MIX_FT_GATEWAY,
            ftGateway: gtwPw,
            showCpDonation: showDonation,

            dictionary: {
                messages: {
                    required: () => "This field is required",
                    email: () => "This field must be a valid email",
                    date_format: () => "This field must be a valid date",
                    numeric: () => "This field is number only",
                    regex: () => "This field must be a valid mobile, start with 04 and no spaces",
                },
            },
        };
    },
    computed: {
        donationTotal() {
            return this.$store.getters["donation/donationTotal"];
        },
        paymentErrors() {
            return this.$store.getters["teamnomination/paymentErrors"];
        },
        teamnominationErrors() {
            return this.$store.getters["teamnomination/teamnominationErrors"];
        },
        teamnominationCart() {
            return this.$store.getters["teamnomination/teamnominationCart"];
        },
        getPaymentMessage() {
            if (this.paymentErrors.any()) {
                if (this.paymentErrors.has("error_response")) {
                    return this.paymentErrors.get("error_response");
                }

                if (this.paymentErrors.has("error_division")) {
                    this.team.divisiongroup = "";
                    this.team.division = "";
                    this.team.preferreddivision = "";

                    this.gradeDiv = "";
                    this.minPlayers = 5;
                    this.maxPlayers = null;
                    this.skipVal = false;
                    this.skTmVal = false;
                    this.showpreferredwaitlist = false;
                    this.requiredpreferredwaitlist = false;

                    return this.paymentErrors.get("error_division");
                }

                if (this.paymentErrors.has("error_validation")) {
                    return "Attendee / Assign Data Invalid";
                }

                if (this.paymentErrors.has("error_payment")) {
                    return this.paymentErrors.get("error_payment");
                }

                return "Payment Invalid";
            }

            return "";
        },
        payLoading() {
            return this.$store.getters["teamnomination/paymentStatus"] == "loading";
        },
        payHtml() {
            if (this.grandTotal > 0 && this.user.sk_tm == false) {
                return "Pay Team Nomination";
            }

            return "Complete Team Nomination";
        },
        subTotal() {
            if (!_.isEmpty(this.teamnominationCart)) {
                return this.teamnominationCart.p_price;
            }

            return 0.0;
        },
        taxTotal() {
            return this.subTotal / (taxRate + 1);
        },
        grandTotal() {
            return this.subTotal - this.discountTotal + this.donationTotal;
        },
        user() {
            return this.$store.getters["user/getProfile"];
        },
        states() {
            return this.$store.getters["common/getData"]("states");
        },
        localities() {
            return this.$store.getters["common/getData"]("localities");
        },
        grades() {
            return this.$store.getters["teamnomination/grades"];
        },
        seasons() {
            return this.$store.getters["teamnomination/seasons"];
        },
        teams() {
            return this.$store.getters["team/teams"].filter(team => {
                // return team.t_division_status && team.t_season_status && !team.t_season_archived;
                let t_created = moment(team.t_created, "YYYY-MM-DD");
                let this_year = moment();
                let diff_created = this_year.diff(t_created, 'days');

                return diff_created <= 365;
            });
        },
        divisiongroups() {
            return this.$store.getters["teamnomination/divisiongroups"];
        },
        divisions() {
            return this.$store.getters["teamnomination/divisions"];
        },
        preferreddivisions() {
            return this.$store.getters["teamnomination/preferreddivisions"];
        },
        teamNomStatus() {
            return "success" != this.$store.getters["teamnomination/teamnominationStatus"];
        },
        length() {
            return this.players.length;
        },
    },
    watch: {
        user() {
            if (!_.isEmpty(this.user)) {
                this.manager = Object.assign({}, this.user);
                this.skTmVal = this.user.sk_tm_val;

                // this.locSubs.push({postcode:this.manager.postcode, state:this.manager.state, text:this.manager.suburb, value:this.manager.suburb});
                this.dateDOB.manager = moment(this.manager.dob, "DD/MM/YYYY").format("YYYY-MM-DD");
            }
        }
    },
    methods: {
        submitStep(scope) {
            this.alert = false;
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.teamnomStep++;
                    if (this.teamnomStep >= 6) {
                        this.editablePanel = true;
                    }
                } else {
                    this.alert = true;
                }
            });
        },
        copyTeam() {
            let self = this;
            this.players = [];
            _.forEach(this.teamSel.t_players, function(playerT, key) {
                self.players.push({
                    firstname: playerT.firstname,
                    lastname: playerT.lastname,
                    dob: "",
                    gender: "",
                    mid: playerT.mid,
                    email: "",
                    rep: false,
                    requireEmail: false,
                    status: "Player Found",
                    btn: "ADD PLAYER",
                    confirm: true,
                    click: false,
                    copied: true,
                });
            });
            this.team.teamname = this.teamSel.t_name;
            this.team.prevteamname = this.teamSel.t_name;
            this.team.teamprevious = this.teamSel.t_id;
            this.overlay = true;
            this.overlayText = "Team copied";
            this.teamnomStep++;
            this.showprev = false;

            setTimeout(() => {
                this.overlay = false;
            }, this.timeout);
        },
        save(type) {
            this.modalDOB[type] = false;
            this[type].dob = this.dateDOB[type] ? moment(this.dateDOB[type]).format("DD/MM/YYYY") : "";
        },
        onChangeGrade() {
            this.$store.dispatch("teamnomination/getDivisionGroups", { division_type: this.team.grade});
            this.team.divisiongroup = "";
            this.team.division = "";
            this.team.preferreddivision = "";

            this.gradeDiv = "";
            this.minPlayers = 5;
            this.maxPlayers = null;
            this.skipVal = false;
            this.skTmVal = false;
            this.showpreferredwaitlist = false;
            this.requiredpreferredwaitlist = false;

            if (this.editablePanel) {
                this.players = [];
            }
        },
        onChangeDivisionGroup() {
            if(this.team.divisiongroup){
                this.$store.dispatch("teamnomination/getDivisions", { division_group: this.team.divisiongroup});
                this.team.division = "";
                this.team.preferreddivision = "";

                this.gradeDiv = "";
                this.minPlayers = 5;
                this.maxPlayers = null;
                this.skipVal = false;
                this.skTmVal = false;
                this.showpreferredwaitlist = false;
                this.requiredpreferredwaitlist = false;

                // if (this.editablePanel) {
                //     this.players = [];
                // }
            }
        },
        onChangeDivision() {
            if (this.team.division) {
                let _self = this;
                this.$store.dispatch("teamnomination/teamnominationRequest", { division: this.team.division })
                .then(function(resp){
                    if(resp.status == 422){
                        console.log('refresh divisions');
                        // _self.team.divisiongroup = "";
                        _self.team.division = "";
                        _self.team.preferreddivision = "";

                        _self.gradeDiv = "";
                        _self.minPlayers = 5;
                        _self.maxPlayers = null;
                        _self.skipVal = false;
                        _self.skTmVal = false;
                        _self.showpreferredwaitlist = false;
                        _self.requiredpreferredwaitlist = false;

                        _self.overlay = true;
                        _self.overlayText = "Division Group has already reached maximum capacity.";
                        _self.overlayColor = "error";

                        setTimeout(() => {
                            _self.overlay = false;
                            _self.overlayText = "";
                            _self.overlayColor = "primary";
                        }, _self.timeout * 2);
                    }
                });

                if (this.team.grade && this.team.divisiongroup && this.team.division) {
                    let self = this;
                    let divisionSel = this.divisions.filter(function(o) {
                        return o.value == self.team.division;
                    });

                    this.gradeDiv = divisionSel[0].text;
                    this.showpreferredwaitlist = false;
                    this.requiredpreferredwaitlist = false;
                    this.team.preferreddivision = "";

                    if (divisionSel[0].waitlist){
                        this.$store.dispatch("teamnomination/getPreferredDivisions", { division: this.team.division });
                        this.showpreferredwaitlist = true;
                        this.requiredpreferredwaitlist = true;
                    }

                    this.minPlayers = divisionSel[0].min_players !== '' ? divisionSel[0].min_players : 5;
                    this.maxPlayers = divisionSel[0].max_players;
                    this.skipVal = divisionSel[0].sk_val;
                    this.skTmVal = this.user.sk_tm_val;

                    if (this.editablePanel && !divisionSel[0].waitlist) {
                        this.players = [];
                    }

                } else {
                    this.gradeDiv = "";
                    this.showpreferredwaitlist = false;
                    this.requiredpreferredwaitlist = false;
                    this.team.preferreddivision = "";
                    this.minPlayers = 5;
                    this.maxPlayers = null;
                    this.skipVal = false;
                    this.skTmVal = false;
                }
            } else {
                this.team.division = "";
                this.team.preferreddivision = "";

                this.gradeDiv = "";
                this.minPlayers = 5;
                this.maxPlayers = null;
                this.skipVal = false;
                this.skTmVal = false;
                this.showpreferredwaitlist = false;
                this.requiredpreferredwaitlist = false;
            }
        },
        onChangePreferredDivision() {
            this.requiredpreferredwaitlist = true;

            if (this.team.preferreddivision) {
                this.requiredpreferredwaitlist = false;
            }
        },
        addPlayer: function(e) {
            e.preventDefault();
            this.players.push({
                firstname: "",
                lastname: "",
                dob: "",
                gender: "",
                email: "",
                mid: "",
                rep: false,
                requireEmail: false,
                status: "",
                btn: "ADD PLAYER",
                confirm: false,
                click: false,
                copied: false,
            });
        },
        removePlayer: function(index) {
            this.players.splice(index, 1);
            this.overlay = true;
            this.overlayText = "Player removed";
            this.overlayColor = "primary";

            setTimeout(() => {
                this.overlay = false;
            }, this.timeout);
        },
        checkPlayer: function(index) {
            if (this.players[index].firstname && this.players[index].lastname && ((this.players[index].dob && this.players[index].gender) || this.players[index].mid)) {
                let playerData = this.players;
                let hasDuplicatePlayer = _.size(
                    _.filter(this.players, function(o) {
                        return o.firstname == playerData[index].firstname && o.lastname == playerData[index].lastname;
                    })
                );
                if (hasDuplicatePlayer <= 1) {
                    this.$store
                        .dispatch("teamnomination/checkPlayer", { player: this.players[index], division: this.team.division, fromteamentry: true })
                        .then(resp => {
                            this.players[index].confirm = true;
                            this.players[index].click = true;

                            if(resp.data == 'Player Found'){
                                this.players[index].requireEmail = false;
                            }

                            this.players[index].status = resp.data;
                            this.players[index].btn = "PLAYER ADDED";

                            this.overlay = true;
                            this.overlayColor = "primary";
                            this.overlayText = "Player added";

                            setTimeout(() => {
                                this.overlay = false;
                            }, this.timeout);
                        })
                        .catch(err => {
                            this.players[index].click = true;
                            this.players[index].requireEmail = false;
                            this.players[index].confirm = false;

                            if (err == "Email required") {
                                this.players[index].requireEmail = true;
                            }

                            this.players[index].status = err;
                        });
                } else {
                    this.overlay = true;
                    this.overlayText = "Player already added to the team";
                    this.overlayColor = "error";
                }
            }
        },
        clearPay() {
            this.alert = false;
            EventBus.$emit("clear-pay");
            this.$store.dispatch("teamnomination/clearPaymentErrors");
        },
        payTeamNomination: function() {
            if (this.grandTotal > 0 && this.user.sk_tm == false) {
                EventBus.$emit("submit-pay");
            } else {
                this.submitPay();
            }
        },
        submitPay: function(payload) {
            this.alert = false;
            this.validPaymentForm = true;

            this.$validator.validateAll("step2").then(result => {
                if (result) {
                    this.$validator.validateAll("step3").then(result => {
                        if (result) {
                            this.$validator.validateAll("step4").then(result => {
                                if (result) {
                                    this.$validator.validateAll("step5").then(result => {
                                        if (result) {
                                            this.$validator.validateAll("step6").then(result => {
                                                if (result) {
                                                    this.$validator.validateAll("step7").then(result => {
                                                        if (result) {
                                                            this.$validator.validateAll("step8").then(result => {
                                                                if (result) {
                                                                    this.validPaymentForm = false;

                                                                    // const cardNumber = this.paymentForm.cardNumber;
                                                                    // const cardHolder = this.paymentForm.cardHolder;
                                                                    // const cardExpiry = this.paymentForm.cardExpiry;
                                                                    // const cardCVC = this.paymentForm.cardCvc;

                                                                    const cardPayload = payload;

                                                                    const manager = this.manager;
                                                                    const coach = this.coach;
                                                                    const team = this.team;
                                                                    const players = this.players;
                                                                    const note = this.note;
                                                                    const teamCopy = this.teamSel;
                                                                    const donationCart = this.$store.getters["donation/donationCart"];

                                                                    this.$store
                                                                        .dispatch("teamnomination/payTeamNomination", {
                                                                            // cardNumber,
                                                                            // cardHolder,
                                                                            // cardExpiry,
                                                                            // cardCVC,
                                                                            cardPayload,

                                                                            manager,
                                                                            coach,
                                                                            team,
                                                                            players,
                                                                            note,
                                                                            teamCopy,
                                                                            donationCart,
                                                                        })
                                                                        .then(NewId => {
                                                                            if (this.user.sk_tm == true) {
                                                                                this.overlayText = "Team Entry was successful.";
                                                                                // this.overlay = true;
                                                                                // this.overlayColor = "primary";
                                                                                this.paysuccess = true;

                                                                                setTimeout(() => {
                                                                                    this.$router.push({ name: "teamDetail", params: { team_id: NewId } });
                                                                                }, this.timeout / 4);
                                                                            } else {
                                                                                this.overlayText = "Payment was successful.";
                                                                                // this.overlay = true;
                                                                                // this.overlayColor = "primary";
                                                                                this.paysuccess = true;

                                                                                setTimeout(() => {
                                                                                    // this.$store
                                                                                    //     .dispatch("order/orderRequest")
                                                                                    //     .then(() => {
                                                                                            this.$router.push({ name: "orderDetail", params: { order_id: NewId } });
                                                                                        // })
                                                                                        // .catch();
                                                                                }, this.timeout / 4);
                                                                            }
                                                                        })
                                                                        .catch(err => {
                                                                            this.validPaymentForm = true;
                                                                            this.alert = true;

                                                                            setTimeout(() => {
                                                                                EventBus.$emit("clear-pay");
                                                                            }, 500);
                                                                        });
                                                                } else {
                                                                    this.alert = true;
                                                                }
                                                            });
                                                        } else {
                                                            this.alert = true;
                                                        }
                                                    });
                                                } else {
                                                    this.alert = true;
                                                }
                                            });
                                        } else {
                                            this.alert = true;
                                        }
                                    });
                                } else {
                                    this.alert = true;
                                }
                            });
                        } else {
                            this.alert = true;
                        }
                    });
                } else {
                    this.alert = true;
                }
            });
        },
        setLocation(suburb, type) {
            if (suburb) {
                let locality = [];

                locality = this.localities.filter(function(object) {
                    return object.value == suburb;
                })[0];

                this[type].postcode = locality.postcode;
                this[type].state = locality.state;
            }
        },
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    beforeCreate() {
        this.$store.dispatch("user/userRequest");
        this.$store.dispatch("team/teamRequest");
        this.$store.dispatch("teamnomination/getSeasons");

        if (_.isEmpty(this.$store.getters["common/getData"]("localities"))) {
            this.$store.dispatch("common/dataRequest", { type: "localities" });
        }

        if (_.isEmpty(this.$store.getters["common/getData"]("states"))) {
            this.$store.dispatch("common/dataRequest", { type: "states" });
        }

        if (_.isEmpty(this.$store.getters["teamnomination/grades"])) {
            this.$store.dispatch("teamnomination/getGrades");
        }

        // if(_.isEmpty(this.$store.getters['teamnomination/divisions'])){
        //     this.$store.dispatch('teamnomination/getDivisions');
        // }
    },
};
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.v-application .v-btn+.v-btn {
    margin-left: 8px;
}

@media screen and (max-width: 768px) {
    .mobile-responsive .v-stepper--vertical .v-stepper__step {
        padding: 10px;
    }
    .mobile-responsive .v-stepper--vertical .v-stepper__content {
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
    }
    .mob-block {
        width: 100% !important;
    }
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}

.v-alert .v-alert__icon.v-icon {
    align-self: flex-start;
}

.v-input--checkbox .v-label {
    height: auto !important;
}
</style>
